import { HostListener, Component } from '@angular/core';

import {
    NavController,
    NavParams,
    PopoverController,
    ViewController } from 'ionic-angular';

import { Horse } from '../../../../model/horse';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { Winner } from '../../../../model/winner';

import { AlertMessager } from "../../../../lib/alertMessager";
import { HorseSearchPopover } from "../../../search/horse-search";
import { UserService } from "../../../../services/user.service";
import { UserSearchPopover } from '../../../search/user-search';
import { AddHorsePage } from '../../../horse/add-horse';
import { AccountHelper } from '../../../../lib/accountHelper';
import { HorseService } from '../../../../services/horse.service';
import { LoadingController } from 'ionic-angular';
import { WinnerService } from '../../../../services/winner.service';

@Component({
    selector: 'page-new-winner',
    templateUrl: 'new-winner.html'
})
export class NewWinnerPage {
    rodeoEvent: RodeoEvent;

    winner: Winner;

    showTeammate: boolean = false;  
    showHorse: boolean = false;  

    contestantOneName: string;
    teammateName: string;
    horseOneName: string;
    horses: Horse[];

    swapTeammate: boolean;
    editing: boolean;
    popoverActive: boolean = false;

    constructor(private nav : NavController, navParams : NavParams, private horseService : HorseService,  private popoverController : PopoverController, private loadingControl : LoadingController,
                private winnerService : WinnerService, private alert : AlertMessager, private userService : UserService, private viewController : ViewController) {
        this.rodeoEvent = navParams.get('rodeoEvent');

        this.winner = new Winner();
        this.winner.rodeoEventId = this.rodeoEvent.id;
        this.winner.name = 'Average';
        this.winner.place = this.rodeoEvent.winners.length + 1;
        this.winner.time = 0;
        this.winner.score = 0;
        this.winner.payout = 0;    
        this.winner.edited = true;

        this.showTeammate = this.rodeoEvent.eventType == 'TeamRoping';
        this.showHorse = this.rodeoEvent.eventType == 'BarrelRacing' || this.rodeoEvent.eventType == 'Tie-Down' || this.rodeoEvent.eventType == 'SteerWrestling';
        
        this.userService.getHorses(AccountHelper.instance().token.id)
        .then(data => {
            this.horses = data as Horse[];
        })
        .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
    }

    openUserSearch(searchEvent, teammateSearch) {
        if (this.popoverActive)
			return;

		this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: (teammateSearch ? this.getSecondLabel(this.rodeoEvent) : this.getFirstLabel(this.rodeoEvent)) + " Search"
        }, { cssClass: 'user-search' });
    
        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null && data.buddies != undefined && data.buddies[0] != undefined) {
                if (teammateSearch) {
                    this.teammateName = data.buddies[0].firstName + ' ' + data.buddies[0].lastName;
                    this.winner.contestantTwoId = data.buddies[0].id;
                    this.winner.contestantTwo = data.buddies[0];
                } else {
                    this.contestantOneName = data.buddies[0].firstName + ' ' + data.buddies[0].lastName;
                    this.winner.contestantOneId = data.buddies[0].id;
                    this.winner.contestantOne = data.buddies[0];
                }
            }
        })
    }

    openHorseSearch(event, horses) {
        if (this.popoverActive)
			return;

		this.popoverActive = true;

        let popover = this.popoverController.create(HorseSearchPopover, {
            searchTitle: "Horse Search",
            horses: horses
        }, { cssClass: 'horse-search' });
    
        popover.present({ ev: event });

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                this.horseOneName = (data.horse as Horse).name;
                this.winner.horseOne = (data.horse as Horse);
                this.winner.horseOneId = (data.horse as Horse).id;
            }
        });
    }

    openSecondSearch(event) {
        if (this.winner.contestantOne == null) {
            this.alert.showError("Error", "You must select a contestant first.");
        } else {
            if (this.rodeoEvent.eventType == "TeamRoping") {
                this.openUserSearch(event, true);
            } else {
                let loading = this.loadingControl.create({
                    content: "Retrieving user's horses...",
                });

                loading.present();
                this.horseService.getHorses([this.winner.contestantOne.id])
                .then((data) => {
                    loading.dismiss();
                    this.openHorseSearch(event, (data as Horse[]));
                }, error => {
                    loading.dismiss();
                    this.alert.showError("Horse Retrieval", "Unable to retrieve user horses.");
                });
            }
        }
    }

    getFirstLabel(rodeoEvent: RodeoEvent) {
        switch (rodeoEvent.eventType) {
            case 'TeamRoping':
                return 'Header';
            default:
                return 'Rider';            
        }
    }

    getSecondLabel(rodeoEvent: RodeoEvent) {
        switch (rodeoEvent.eventType) {
            case 'TeamRoping':
                return 'Heeler';
            case 'BarrelRacing':
                return 'Horse';            
            default:
                return "Livestock";
        }
    }

    addHorse() {
        if (this.popoverActive)
			return;

		this.popoverActive = true;

        let popover = this.popoverController.create(AddHorsePage, {}, { cssClass: 'page-add-horse' });
    
        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                this.horseOneName = (data as Horse).name;
                this.winner.horseOneId = (data as Horse).id;
                this.horses.push(data);
            }
        })
    }

    create() {
        if (this.rodeoEvent.eventType == 'TeamRoping' && (this.winner.contestantTwoId == null || this.winner.contestantTwoId == undefined)) {
            this.alert.showError("Winner Invalid", "You must select a teammate.");
            return;
        }

        this.winnerService.addWinner(this.winner)
        .then(data => {
            if ((data as any).message != null && (data as any).message != undefined) {
                this.alert.showError("Winner Failed", (data as any).message);
            } else {
                this.viewController.dismiss({winner: data });
            }
        }, error => { 
                this.alert.showError("Winner Create Error", error); 
        });
    }

    cancel() {
        this.nav.pop();
    }

    back() {
        this.nav.pop();
    }

    _bdClick() {
        return this.nav.pop();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast() && !this.popoverActive) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/new-winner.ts